export default function memoise(fn) {
    let rootCache = new WeakMap();
    let primitives = {};
    return (...args) => {
        let objargs = args.filter(arg => typeof arg == "object");
        let primargs = "" + args.filter(arg => typeof arg != "object");

        if (objargs.length == 0) {
            objargs = [primitives];
        }

        let cache = objargs.reduce((cache, arg, i, arr) => {
            if (!cache.has(arg)) {
                cache.set(arg, i == arr.length - 1 ? {} : new WeakMap());
            }
            return cache.get(arg);
        }, rootCache);

        if (!cache.hasOwnProperty(primargs)) {
            cache[primargs] = fn(...args);
        }

        return cache[primargs];
    };
}


// WEBPACK FOOTER //
// ./src/lib/memoize.js